module.exports = __webpack_public_path__ + "img/logo.d532b23a.jpg";